<script setup>
import { goToLogin } from '@/utils/loginFlow'
import { ref, onMounted } from 'vue';
import { ElMessage } from 'element-plus';
import { useRouter } from 'vue-router';
import AdminPagination from '@/components/AdminPagination.vue';

const router = useRouter();

// 检查是否登录
const checkLogin = () => {
  if (!localStorage.getItem('jwt_token')) {
    goToLogin(router)
    return false
  }
  return true
}

// State
const rechargeList = ref([]);
const total = ref(0);
const currentPage = ref(1);
const pageSize = ref(10);
const loading = ref(false);

// Format amount helper
function formatAmount(value) {
  if (!value && value !== 0) return '0.00';
  return (Number(value) / 100).toFixed(2);
}

// Format date helper
function formatDate(timestamp) {
  return new Date(timestamp * 1000).toLocaleString();
}

// Get recharge list
async function getRechargeList() {
  try {
    loading.value = true;
    const token = localStorage.getItem('jwt_token');
    const response = await fetch('/api/v1/recharge/list', {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        page: currentPage.value,
        pageSize: pageSize.value,
        payMethod: 0,
      })
    });

    const data = await response.json();
    if (data.code === 200) {
      rechargeList.value = data.data.orders || [];
      total.value = data.data.total || 0;
    } else {
      ElMessage.error(data.message || '获取充值记录失败');
    }
  } catch (error) {
    console.error('Failed to fetch recharge list:', error);
    ElMessage.error('获取充值记录失败');
  } finally {
    loading.value = false;
  }
}

// Handle page change
function handlePageChange(page) {
  currentPage.value = page;
  getRechargeList();
}

// Handle page size change
function handleSizeChange(size) {
  pageSize.value = size;
  currentPage.value = 1;
  getRechargeList();
}

onMounted(() => {
  // 检查是否登录
  if (!checkLogin()) {
    return
  }
  getRechargeList();
});
</script>

<template>
  <div class="recharge-list-container">
    <div class="card">
      <h2>充值记录</h2>
      <el-table
        v-loading="loading"
        :data="rechargeList"
        style="width: 100%"
        border
      >
        <el-table-column
          prop="orderNo"
          label="订单号"
          width="180"
        />
        <el-table-column
          prop="amount"
          label="金额"
          width="120"
        >
          <template #default="{ row }">
            ¥{{ formatAmount(row.amount) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="status"
          label="状态"
          width="100"
        >
          <template #default="{ row }">
            <el-tag :type="row.status === 'completed' ? 'success' : 'danger'">
              {{ row.status === 'completed' ? '成功' : '失败' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="createdAt"
          label="创建时间"
          width="180"
        >
          <template #default="{ row }">
            {{ formatDate(row.createdAt) }}
          </template>
        </el-table-column>
      </el-table>

      <AdminPagination
        v-model:current-page="currentPage"
        v-model:page-size="pageSize"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
      />
    </div>
  </div>
</template>

<style scoped>
.recharge-list-container {
  padding: 20px;
  max-width: 1800px;
  margin: 0 auto;
}

.card {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 20px;
}

.pagination-container {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}
</style> 